import { useMemo } from 'react';

import { ResourceRegionType } from '#shared';

import { regionToStatesMap } from '../helpers';
// eslint-disable-next-line import-x/no-internal-modules
import { mainMapOverlayClasses } from '../Overlays/ui/MapOverlay.styled';

import type { HubReportStatus } from '#entities';

type RegionAlignment = 'horizontal' | 'vertical';

export const useRegionedHubs = (hubs: HubReportStatus[]) => {
  const { leftHubs, bottomHubs, topHubs, rightHubs } = useMemo(
    () => ({
      leftHubs: hubs
        .filter(h => regionToStatesMap.west.includes(h.location.state))
        .toSorted((a, b) => b.location.lonLat[1] - a.location.lonLat[1]),
      bottomHubs: hubs
        .filter(h => regionToStatesMap.south.includes(h.location.state))
        .toSorted((a, b) => a.location.lonLat[0] - b.location.lonLat[0]),
      topHubs: hubs
        .filter(h => regionToStatesMap.north.includes(h.location.state))
        .toSorted((a, b) => a.location.lonLat[0] - b.location.lonLat[0]),
      rightHubs: hubs
        .filter(h => regionToStatesMap.east.includes(h.location.state))
        .toSorted((a, b) => b.location.lonLat[1] - a.location.lonLat[1]),
    }),
    [hubs],
  );
  const regions: {
    key: ResourceRegionType;
    region: ResourceRegionType;
    hubs: HubReportStatus[];
    alignment: RegionAlignment;
    className: string;
  }[] = useMemo(
    () => [
      {
        key: ResourceRegionType.West,
        hubs: leftHubs,
        alignment: 'vertical',
        region: ResourceRegionType.West,
        className: mainMapOverlayClasses.leftHubs,
      },
      {
        key: ResourceRegionType.North,
        hubs: topHubs,
        alignment: 'horizontal',
        region: ResourceRegionType.North,
        className: mainMapOverlayClasses.topHubs,
      },
      {
        key: ResourceRegionType.South,
        hubs: bottomHubs,
        alignment: 'horizontal',
        region: ResourceRegionType.South,
        className: mainMapOverlayClasses.bottomHubs,
      },
      {
        key: ResourceRegionType.East,
        hubs: rightHubs,
        alignment: 'vertical',
        region: ResourceRegionType.East,
        className: mainMapOverlayClasses.rightHubs,
      },
    ],
    [leftHubs, rightHubs, topHubs, bottomHubs],
  );

  return {
    regions,
  };
};
